import { type FC, memo } from "react";
import { type KeyValue, KeyValueTable } from "@/components/fragments/table/key-value-table";
import { type ChildFormValue } from "@/components/fragments/argyle";
import { childTableLabelTestId, childTableTestId } from "./const";
import { Box } from "@/components/essentials/box";
import { Typography } from "@/components/essentials/typography";
import { childSexes } from "@/components/fragments/forms/child-sex-form/const";
import { formatAsiaTokyoDateToString } from "@/modules/utils/date";

export interface ChildTableProps {
  readonly value: ChildFormValue;
}

export const ChildTable: FC<ChildTableProps> = memo(
  ({
    value: {
      child: { birthDate, sexCode },
    },
  }) => {
    const childKeyValueData: KeyValue[] = [
      {
        key: "性別",
        value: childSexes.find(({ sexCode: value }) => value === sexCode)?.label ?? "",
      },
      {
        key: "生年月日",
        value: formatAsiaTokyoDateToString(birthDate, "yyyy年MM月dd日", "yyyyMMdd"),
      },
    ];

    return (
      <Box data-testid={childTableTestId}>
        <Typography variant="display6" mb="4" data-testid={childTableLabelTestId}>
          お子様の情報
        </Typography>
        <KeyValueTable data={childKeyValueData} />
      </Box>
    );
  },
);

ChildTable.displayName = "ChildTable";
